import {
  isValidDateState,
  contentScheduledState,
} from 'Components/ContentScheduled/recoil/state'
import { atom, selector } from 'recoil'
import { abTestState } from './abTest'

export const pageState = atom({
  key: 'AbTestManagePageState',
  default: {
    loaded: false,
    showLoader: false,
    loadingResult: true,
    loading: false,
    error: false,
    severity: 'danger',
  },
})

export const modalStopTestState = atom({
  key: 'AbTestManageShowmodalStopTestState',
  default: {
    showModalStopTest: false,
  },
})

export const modalResumeTestState = atom({
  key: 'AbTestManageShowmodalResumeTestState',
  default: {
    showModalResumeTest: false,
  },
})

export const modalStopSendingWinnerState = atom({
  key: 'AbTestManageStopSendingWinnerSate',
  default: {
    showModalStopSendingWinner: false,
  },
})

export const abTestManageIsValidState = selector({
  key: 'abTestManageIsValidSate',
  get: ({ get }) => {
    const {
      Info,
      testNotStartMode,
      schedulingAutomatic,
      testEnded,
      idWinnerMessageManual,
    } = get(abTestState)
    const isValidDate = get(isValidDateState)

    if (testNotStartMode) {
      if (!Info.Nome) {
        return false
      } else if (Info.TipoTest === 'A' && !schedulingAutomatic) {
        return false
      } else if (!isValidDate) {
        return false
      } else {
        return true
      }
    } else {
      if (testEnded && Info.TipoTest === 'M' && !idWinnerMessageManual) {
        return true
      } else {
        return true
      }
    }
  },
})

export const isStartDateChangedState = selector({
  key: 'abTestManageIsStartDateChanged',
  get: ({ get }) => {
    const { Info } = get(abTestState)
    const { momentTimeZoneDate, timeZone } = get(contentScheduledState)

    if (
      momentTimeZoneDate.format('YYYY-MM-DDTHH:mm:ss[Z]') !==
      Info.TestDateCTZScheduled
    ) {
      return true
    } else if (timeZone !== Info.TimeZoneScheduled) {
      return true
    } else {
      return false
    }

    //     ###momentTimeZoneDate 2023-02-04T20:55:00+07:00
    // page.js:69 ###Info 2023-02-04T16:55:00Z

    return false
  },
})
